<template>
  <div>
    <v-menu
      bottom
      left
      min-width="100"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list
        dense
        class="pa-0"
      >
        <v-list-item
          :disabled="
            account.verified || !$store.getters.checkUserPrivilege('ACC_VERIFY')
          "
          @click="verify()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-shield-check
            </v-icon>
            Verify
          </v-list-item-title>
        </v-list-item>
        <v-divider />

        <v-list-item
          :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
          @click="enableEditAccount()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-circle-edit-outline
            </v-icon>
            Edit Account
          </v-list-item-title>
        </v-list-item>
        <v-divider />

        <v-list-item
          v-if="account.activeStatus"
          :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
          @click="inActivate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-lightbulb-off
            </v-icon>
            In-activate
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-else
          :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
          @click="activate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-lightbulb-on
            </v-icon>
            Activate
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item
          :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
          @click="enableFeedback(true)"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-thumb-up
            </v-icon>
            Enable Feedback
            <v-icon
              v-show="account.feedback"
              small
              right
              color="success"
            >
              mdi-check
            </v-icon>
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item
          :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
          @click="enableFeedback(false)"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-thumb-down
            </v-icon>
            Disable Feedback
            <v-icon
              v-show="!account.feedback"
              small
              right
              color="success"
            >
              mdi-check
            </v-icon>
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item
          :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
          @click="openLinkCorporate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-link-variant
            </v-icon>
            Link To Corporate
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item @click="fetchNotification()">
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-link-variant
            </v-icon>
            Create / Update Alert
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <!-- :disabled="!$store.getters.checkUserPrivilege('LAUNCH_DIGI_APPS')" -->
        <v-list-item
          @click="OpenBackOffice()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="primary"
            >
              mdi-open-in-app
            </v-icon>
            Launch back office
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <link-corporate
      :show-dialog.sync="link"
      :account-id="account.id"
      :corporate-id="account.corporateId"
      @refresh="$emit('reload');"
    />
    <edit-account
      :show-dialog.sync="editAccount"
      :account-id="account.id"
      @refresh="$emit('reload');"
    />
    <edit-alert
      :show-dialog.sync="editAlert"
      :account-id="account.id"
      @refresh="$emit('reload')"
    />
  </div>
</template>

<script>
import { failure } from "@/mixins/common";
import LinkCorporate from "./LinkCorporate";
import EditAccount from "./EditAccount";
import EditAlert from "./EditAlert";

export default {
  name: "AccountOptions",
  components: {
    LinkCorporate,
    EditAccount,
    EditAlert
  },
  mixins: [failure],
  props: {
    account: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      link: false,
      editAccount: false,
      editAlert: false
    };
  },
  methods: {
    verify() {
      this.$http
        .put(`${this.ADMIN_API_URL}/accounts/${this.account.id}/verify`)
        .then(
          (data) => {
            this.handleSuccess(data.body);
          },
          (failure) => {
            this.handleFailure(failure);
          }
        );
    },
    fetchNotification(){
      this.editAlert = true;
    },
    inActivate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to inactivate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/accounts/${this.account.id}/inactivate`)
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    activate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to activate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/accounts/${this.account.id}/activate`)
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    enableFeedback(status) {
      let msg,
        url = `${this.ADMIN_API_URL}/accounts/${this.account.id}/feedbacks`;
      if (status) {
        msg = "Are you sure you want to enable feedback?";
        url += "/enable";
      } else {
        msg = "Are you sure you want to disable feedback?";
        url += "/disable";
      }
      this.$root.$confirm.open("Confirm", msg, {}).then((confirm) => {
        if (!confirm) {
          return;
        }
        this.$http.put(url).then(
          (data) => {
            this.handleSuccess(data.body);
          },
          (failure) => {
            this.handleFailure(failure);
          }
        );
      });
    },
    openLinkCorporate() {
      this.link = true;
    },
    enableEditAccount() {
      this.editAccount = true;
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    },
    OpenBackOffice() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to open the Back Office ?",{})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(`${this.ADMIN_API_URL}/openDigitoryApp`,
               {
                id: this.account.id,
                level: 1,
                token : localStorage.getItem("JwtExhToken"),
                scope : "BACKOFFICE"
              }
            )
            .then(
              (data) => {
                if (data.body.routerLink) {
                  // console.log(data.body.routerLink);
                    window.open(data.body.routerLink, "_blank");
                    // window.location.href = data.body.routerLink;
                }

              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    }
  }
};
</script>
